import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Locale } from 'vant';
import en from './lang/en';
import zhHant from './lang/zh';

Vue.use(VueI18n);

const locale = 'zh-Hant';

// vant切换语言，vant语言包命名规范不同，如下。
// 简体中文 zh-CN
// 英语 en-US
// 繁體中文 zh-TW
switch (locale) {
  case 'en':
    Locale.use('en-US', en);
    break;
  case 'zh-Hant':
    Locale.use('zh-Hant', zhHant);
    break;
  default:
    break;
}

const i18n = new VueI18n({
  locale,
  messages: {
    'zh-Hant': zhHant,
    en
  }
});
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js